export default __webpack_public_path__ + "static/media/news4.dbd9a4e6.jpg";